<script lang="ts">
import { computed, defineComponent } from 'vue';
import { any, object } from 'vue-types';
import { Alert } from 'ant-design-vue';

import ValidationErrors from '../NoDataUrql/ValidationErrors.vue';

import Error404 from '@/templates/Error/Error404.vue';
import { getConfig } from '~/config/constants';
import type { ServerErrors} from '@/util/api/ajax/ApiResponse';
import { RequestCancel, ValidationError } from '@/util/api/ajax/ApiResponse';

const config = getConfig(useRuntimeConfig());

export default defineComponent({
  name: 'ApiErrors',

  components: {
    Error404,
    Alert,
    ValidationErrors,
  },

  props: {
    error: object<ServerErrors>().isRequired,
    class: any(),
  },

  setup(props) {
    const validationError = computed(() => (props.error instanceof ValidationError
      ? props.error.errors
      : undefined));
    const isRequestCancel = computed(() => props.error instanceof RequestCancel);
    const alertProps = computed<{
      type: 'warning' | 'error',
      showIcon: boolean,
      message: string,
    }>(() => {
      if (isRequestCancel.value) {
        return {
          type: 'warning',
          showIcon: false,
          message: props.error.message,
        };
      }
      return {
        type: 'error',
        showIcon: true,
        message: validationError.value ? 'Errors' : props.error.message,
      };
    });
    return {
      env: config.env,
      validationError,
      isRequestCancel,
      alertProps,
    };
  },
});
</script>

<template>
  <div v-if="error.code === '404'">
    <Error404 />
    <div v-if="env !== 'production'" class="bg-red-600 text-white rounded p-3 text-center mt-6">
      Debug message: {{ error.message }}
    </div>
  </div>
  <div v-else :class="$props.class">
    <Alert v-if="validationError" v-bind="alertProps">
      <template #description>
        <ValidationErrors :errors="validationError" />
      </template>
    </Alert>
    <Alert v-else-if="isRequestCancel" v-bind="alertProps" />
    <Alert v-else v-bind="alertProps" />
  </div>
</template>
